/* eslint-disable */
import React from "react";
import last_new_asset from "../../assets/01_Home/Banner_Image.webp";
import read_more_icon from "../../assets/hyundai-icono-ver-mas.svg";
import { Link } from "react-router-dom";

interface LastNewsComponentProps {
  lastNewsData: any;
  category: any;
}

const LastNewsComponent: React.FC<LastNewsComponentProps> = ({
  lastNewsData,
  category,
}) => {
  // Verifica que lastNewsData y Categories existan antes de procesar
  const posts =
    lastNewsData?.Categories?.flatMap((item: any) =>
      item.posts.map((post: any) => ({
        ...post,
        category: item.category, // Accedemos a la categoría del padre
        category_id: item.category_id, // Accedemos al category_id del padre
      }))
    ) || [];

  // Asegúrate de que los posts no estén vacíos y ordénalos por fecha
  if (posts.length > 0) {
    posts.sort(
      (a: any, b: any) =>
        new Date(b.creation_datetime).getTime() -
        new Date(a.creation_datetime).getTime()
    );
  }

  // Obtenemos los 2 posts más recientes
  const twoMostRecentPosts = posts.slice(0, 2);

  // Concatenamos la categoría y el category_id de cada post
  const postsWithCategoryInfo = twoMostRecentPosts.map((post: any) => ({
    ...post,
    categoryInfo: `${post.category} - ${post.category_id}`, // Concatenamos la categoría y el category_id
  }));

  // Si no hay posts, evita errores
  const firstPost = postsWithCategoryInfo[0] || {};
  const secondPost = postsWithCategoryInfo[1] || {};

  console.log(secondPost);

  return (
    <>
      <div className="title-last-news-component">Últimas noticias</div>
      <div className="container-last-news-component">
        {/* Primer post */}
        <div
          className="left-container-last-news-component"
          style={{
            backgroundImage: `URL(https://manager.hyundaicolombia.co/${firstPost?.media?.url})`,
          }}
        >
          <div className="internal-container-last-news-component">
            <div className="description">{firstPost?.title}</div>
            <div className="subtitle">{firstPost?.category}</div>
            <Link
              className="readMore"
              to={`/noticias/${firstPost?.category_id}/${firstPost?.slug}`}
            >
              <div className="txtt">Leer más</div>
              <img src={read_more_icon} className="iconn" alt="" />
            </Link>
          </div>
        </div>

        {/* Segundo post (Con imagen predeterminada si no existe el segundo post) */}
        <div
          className="right-container-last-news-component"
          style={{
            backgroundImage: `URL(https://manager.hyundaicolombia.co/${secondPost?.media?.url})`,
          }}
        >
          <div className="internal-container-last-news-component">
            <div className="description">
              {secondPost?.title ||
                "Hyundai se asociará con entidades gubernamentales para proteger los ecosistemas de carbono azul"}
            </div>
            <div className="subtitle">
              {secondPost?.category || "Categoría de contenido"}
            </div>
            <Link
              className="readMore"
              to={`/noticias/${secondPost?.category_id}/${secondPost?.slug}`}
            >
              <div className="txtt">Leer más</div>
              <img src={read_more_icon} className="iconn" alt="" />
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default LastNewsComponent;
